import { useTranslation } from 'react-i18next';
import { Button } from '@scramble/ui';
import { useResetInvesting } from '@/query/queries/investing/useResetInvesting';
import { useRoundStatus } from '@/hooks/shared/useRoundStatus';
import { scrollTop } from '@/helpers/utils';
import IconReset from '@scramble/design-system/icons/refresh-ccw-01.svg?react';
import s from './index.module.scss';

export const ResetInvesting = () => {
  const { status, addOnly } = useRoundStatus();
  const { t } = useTranslation();
  const { mutateAsync: reset } = useResetInvesting();

  const onReset = async () => {
    await reset();
    scrollTop();
  };

  if (status?.step < 2 || status?.step > 3 || addOnly) return null;

  return (
    <div className={s.wrapper}>
      <div className={s.content}>
        <div className="f-body-md f-500">
          {t('investing:reset_investing.changed_mind')}
        </div>
        <div className="f-body-sm">
          {t('investing:reset_investing.not_participate')}
        </div>
      </div>
      <Button
        theme="neutral"
        appearance="filled"
        size="md"
        className={s.btn_reset}
        onClick={onReset}
      >
        <IconReset />
        <span>{t('investing:reset_investing.reset_investing')}</span>
      </Button>
    </div>
  );
};
